import { Component, Input, OnInit } from '@angular/core';
import { AmKeyboardService } from '@app/shared/components/am-keyboard/am-keyboard.service';
import { unsubscribe } from '@app/utils';
import { Subscription } from 'rxjs';
/**
  Componente para mostrar un modal de carga completa.
  Este componente permite mostrar un modal de carga con opciones configurables,
  como la visualización de botones de "Comenzar de nuevo" y "Idiomas".
  Además, gestiona la visibilidad del teclado virtual.
**/
@Component({
    selector: 'app-modal-full-loading',
    templateUrl: './modal-full-loading.component.html',
    styleUrls: ['./modal-full-loading.component.scss'],
    standalone: false
})
export class ModalFullLoadingComponent implements OnInit {

/**
    Indica si se debe mostrar el ícono de SkyPriority.
  **/
    @Input() skyPriority: boolean = false;

    /**
      Indica si se debe mostrar el botón de "Comenzar de nuevo".
    **/
    @Input() showStartOver: boolean = false;
  
    /**
      Indica si se debe mostrar el botón de "Idiomas".
    **/
    @Input() showLanguagesButton: boolean = false;
  
    /**
      Lista de suscripciones para gestionar la desuscripción en el ciclo de vida del componente.
    **/
    subs: Subscription[] = [];
  
    /**
      Indica si el teclado virtual está visible.
    **/
    isShowKeyboard: boolean = false;
  //#endregion Vars

  constructor(
    public keyboardService: AmKeyboardService,
  ) { }

  ngOnInit(): void {
    this.initSubscriber();
  }

  ngOnDestroy(): void {
    unsubscribe(this.subs);
  }

  //#region Functions internals

  initSubscriber() {
    const subsKeyboard = this.keyboardService.getStatusKeyboard().subscribe({
      next: (res) => {
        this.isShowKeyboard = res;
      },
    });
    this.subs.push(subsKeyboard);
  }


  //#endregion Functions internals

  //#region Events


  //#endregion Events

}
